import {
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES,
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE,
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS,
} from '../actions/types';

const initialState = {
    data: null,
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES:
            return Object.assign({}, state, {
                loading: true,
            });
        case FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });
        case FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.payload.response,
                }),
                loading: false,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/reservationAccessSessionActivitiesReducer.js